import { Fragment, useState, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import ToastHandle from "../Components/ToastHandle";
import { toast } from "react-toastify";

// screens
import Loading from "../Screens/Loading";
import SignIn from "../Screens/SignIn";
import Payment from "../Screens/Payment";
import Result from "../Screens/Result";
import Footer from "../Components/Footer";
import { PaymentInfo } from "../Screens/DaapAppSoftPos/PaymentInfo/PaymentInfo";
import SoftPosePayment from "../Screens/DaapAppSoftPos/Payment";
import TransactionStatus from "../Screens/TransactionStatus";

const App = () => {
  const [timer, setTimer] = useState(600);
  let interval = null;

  useEffect(() => {
    timerActivePage();
    return () => clearInterval(interval);
  }, []);

  const timerActivePage = () => {
    interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) clearInterval(interval);
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (timer === 0) {
      sessionStorage.removeItem("Access_Token");
    }
  }, [timer]);

  return (
    <Fragment>
      <BrowserRouter>
        <Switch>
          <Route exact from="/" component={Loading} />
          <Route exact from="/sign-in" component={SignIn} />
          <Route exact from="/payment" component={Payment} />
          <Route exact from="/result" component={Result} />
          <Route exact from="/transaction-status" component={TransactionStatus} />
          <Route
            exact
            from="/daapapp-softpos/payment-info"
            component={PaymentInfo}
          />
          <Route
            exact
            from="/daapapp-softpos/payment"
            component={SoftPosePayment}
          />
        </Switch>
      </BrowserRouter>
      <ToastHandle />
      {/*<Footer />*/}
    </Fragment>
  );
};
export default App;
